var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKv5 = function SvgKv5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 154,
    viewBox: "0 0 151 154",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114:4867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.394 121.293C141.888 97.7108 141.888 59.4772 118.394 35.8954C94.8996 12.3137 56.8078 12.3137 33.3136 35.8954C9.8193 59.4772 9.8193 97.7108 33.3136 121.293C56.8078 144.874 94.8996 144.874 118.394 121.293Z",
    stroke: "#ED1C24",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8415 33.2291C84.1245 33.2291 90.8392 26.4894 90.8392 18.1755C90.8392 9.86167 84.1245 3.12195 75.8415 3.12195C67.5585 3.12195 60.8438 9.86167 60.8438 18.1755C60.8438 26.4894 67.5585 33.2291 75.8415 33.2291Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0876 11.1619H66.4682C65.957 11.1619 65.4883 11.5895 65.4883 12.1455V23.8633C65.4883 24.3765 65.9144 24.8469 66.4682 24.8469H73.0298V25.5312H72.4333C72.3054 25.5312 72.2202 25.6167 72.2202 25.745C72.2202 25.8733 72.3054 25.9589 72.4333 25.9589H79.08C79.2078 25.9589 79.293 25.8733 79.293 25.745C79.293 25.6167 79.2078 25.5312 79.08 25.5312H78.5261V24.8042H85.0876C85.5989 24.8042 86.0676 24.3765 86.0676 23.8206V12.1455C86.025 11.5895 85.5989 11.1619 85.0876 11.1619ZM85.1302 22.4521H66.4682V12.0599H85.1302V22.4521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.836 16.251H71.1543V20.9552H71.836V16.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8399 18.5603H73.1582V20.998H73.8399V18.5603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8419 14.5404H75.1602V20.9553H75.8419V14.5404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8438 16.251H77.1621V20.9552H77.8438V16.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8048 19.5868H79.123V20.9981H79.8048V19.5868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.828 122.396C131.828 130.693 125.096 137.45 116.83 137.45C108.564 137.45 101.832 130.693 101.832 122.396C101.832 114.099 108.564 107.342 116.83 107.342C125.096 107.342 131.828 114.057 131.828 122.396Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.028 119.103H121.133V130.008H122.028V119.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.387 118.034H118.492V130.008H119.387V118.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.701 121.455H115.807V130.008H116.701V121.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.061 123.722H113.166V130.008H114.061V123.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.418 128.169H110.523V130.008H111.418V128.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.24 115.169L122.155 115.297C121.814 115.34 121.431 115.425 121.09 115.511C114.997 116.965 111.333 121.541 110.48 122.909V117.948C114.486 114.698 118.831 114.613 121.09 114.912C121.516 114.955 121.899 115.04 122.155 115.083L122.24 115.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.241 115.169L122.155 115.297L121.133 116.794V113.757L122.198 115.083L122.241 115.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92195 107.599H4.08984V112.517H5.92195V107.599Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02706 108.198H6.90178L5.96442 107.086L5.02706 106.017L4.0897 107.086L3.15234 108.198H5.02706Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3536 104.007H8.52148V112.517H10.3536V104.007Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4161 104.605H11.2908L10.3535 103.493L9.4161 102.424L8.52134 103.493L7.58398 104.605H9.4161Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7833 99.6445H12.9512V112.517H14.7833V99.6445Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8474 100.243H15.7221L14.7847 99.174L13.8474 98.0621L12.91 99.174L11.9727 100.243H13.8474Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.083 140.358C98.0383 140.358 96.334 142.026 96.334 144.121C96.334 146.217 97.9957 147.884 100.083 147.884C102.171 147.884 103.833 146.217 103.833 144.121C103.833 142.026 102.171 140.358 100.083 140.358ZM100.083 146.388C98.8052 146.388 97.7826 145.361 97.7826 144.078C97.7826 142.795 98.8052 141.769 100.083 141.769C101.362 141.769 102.384 142.795 102.384 144.078C102.384 145.361 101.362 146.388 100.083 146.388Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.553 140.058C100.511 139.844 100.34 139.631 100.17 139.631H100.085H99.8715H99.7863C99.6159 139.631 99.4455 139.802 99.4029 140.058L99.2324 140.743H99.8715H100.085H100.724L100.553 140.058Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5281 140.956C97.3151 140.828 97.0594 140.828 96.9742 140.956L96.9316 140.999L96.7186 141.127L96.6759 141.17C96.5481 141.298 96.5481 141.555 96.6759 141.726L97.0594 142.325L97.4855 141.897L97.6559 141.726L98.082 141.298L97.5281 140.956Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9944 143.736C95.7814 143.779 95.5684 143.95 95.5684 144.121V144.207V144.42V144.506C95.5684 144.677 95.7388 144.848 95.9944 144.891L96.6761 145.062V144.42V144.207V143.565L95.9944 143.736Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8888 146.815C96.761 147.029 96.761 147.286 96.8888 147.371L96.9314 147.414L97.1019 147.585L97.1445 147.628C97.2723 147.756 97.5279 147.756 97.6984 147.628L98.2949 147.243L97.8688 146.815L97.6984 146.644L97.2723 146.217L96.8888 146.815Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6587 148.355C99.7013 148.569 99.8717 148.782 100.042 148.782H100.127H100.34H100.426C100.596 148.782 100.766 148.611 100.809 148.355L100.98 147.671H100.34H100.127H99.4883L99.6587 148.355Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.725 147.457C102.938 147.585 103.194 147.585 103.279 147.457L103.322 147.414L103.492 147.243L103.535 147.2C103.663 147.072 103.663 146.815 103.535 146.644L103.151 146.046L102.725 146.473L102.555 146.644L102.129 147.072L102.725 147.457Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.26 144.634C104.473 144.591 104.686 144.42 104.686 144.249V144.164V143.95V143.864C104.686 143.693 104.515 143.522 104.26 143.48L103.578 143.308V143.95V144.164V144.805L104.26 144.634Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.365 141.598C103.493 141.384 103.493 141.127 103.365 141.042L103.322 140.999L103.152 140.828L103.109 140.785C102.982 140.657 102.726 140.657 102.555 140.785L101.959 141.17L102.385 141.598L102.555 141.769L102.982 142.197L103.365 141.598Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.203 141.683C106.902 141.683 105.027 143.565 105.027 145.874C105.027 148.184 106.902 150.065 109.203 150.065C111.504 150.065 113.378 148.184 113.378 145.874C113.378 143.565 111.504 141.683 109.203 141.683ZM109.203 148.483C107.797 148.483 106.646 147.328 106.646 145.917C106.646 144.506 107.797 143.351 109.203 143.351C110.609 143.351 111.759 144.506 111.759 145.917C111.759 147.328 110.609 148.483 109.203 148.483Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.714 141.341C109.672 141.085 109.459 140.871 109.288 140.871H109.203H108.947H108.862C108.692 140.871 108.479 141.085 108.436 141.341L108.266 142.111H108.947H109.203H109.885L109.714 141.341Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.305 142.368C106.092 142.239 105.794 142.239 105.666 142.368L105.623 142.41L105.453 142.582L105.41 142.624C105.282 142.753 105.282 143.052 105.41 143.266L105.836 143.907L106.348 143.394L106.518 143.223L107.029 142.71L106.305 142.368Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.559 145.49C104.303 145.532 104.09 145.746 104.09 145.917V146.003V146.259V146.345C104.09 146.516 104.303 146.73 104.559 146.773L105.325 146.944V146.259V146.003V145.318L104.559 145.49Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.58 148.954C105.452 149.167 105.452 149.467 105.58 149.595L105.623 149.638L105.793 149.809L105.836 149.852C105.964 149.98 106.262 149.98 106.475 149.852L107.114 149.424L106.603 148.911L106.432 148.74L105.921 148.227L105.58 148.954Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.735 150.664C108.777 150.921 108.991 151.135 109.161 151.135H109.246H109.502H109.587C109.757 151.135 109.97 150.921 110.013 150.664L110.184 149.895H109.502H109.246H108.564L108.735 150.664Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.142 149.681C112.355 149.809 112.654 149.809 112.781 149.681L112.824 149.638L112.994 149.467L113.037 149.424C113.165 149.296 113.165 148.996 113.037 148.783L112.611 148.141L112.1 148.654L111.929 148.825L111.418 149.339L112.142 149.681Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.89 146.516C114.146 146.473 114.359 146.259 114.359 146.088V146.003V145.746V145.661C114.359 145.49 114.146 145.276 113.89 145.233L113.123 145.062V145.746V146.003V146.687L113.89 146.516Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.868 143.052C112.996 142.838 112.996 142.539 112.868 142.41L112.825 142.368L112.655 142.197L112.612 142.154C112.484 142.026 112.186 142.026 111.973 142.154L111.334 142.582L111.845 143.095L112.016 143.266L112.527 143.779L112.868 143.052Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 55.6384C151 53.0724 147.932 51.0197 144.182 51.0197C140.433 51.0197 137.365 53.0724 137.365 55.6384C137.365 58.2043 140.433 60.2571 144.182 60.2571C145.29 60.2571 146.313 60.086 147.25 59.7439L149.21 61.1979L148.784 59.0596C150.147 58.2043 151 56.9641 151 55.6384Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.051 55.6384C142.051 56.0233 141.753 56.3226 141.369 56.3226C140.986 56.3226 140.688 56.0233 140.688 55.6384C140.688 55.2535 140.986 54.9541 141.369 54.9541C141.753 54.9541 142.051 55.2535 142.051 55.6384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.863 55.6384C144.863 56.0233 144.565 56.3226 144.182 56.3226C143.798 56.3226 143.5 56.0233 143.5 55.6384C143.5 55.2535 143.798 54.9541 144.182 54.9541C144.523 54.9541 144.863 55.2535 144.863 55.6384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.633 55.6384C147.633 56.0233 147.335 56.3226 146.951 56.3226C146.568 56.3226 146.27 56.0233 146.27 55.6384C146.27 55.2535 146.568 54.9541 146.951 54.9541C147.335 54.9541 147.633 55.2535 147.633 55.6384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50234 47.2563C11.8031 47.2563 13.7631 48.7959 14.4022 50.9342H16.3621C15.6804 47.7695 12.8683 45.3746 9.50234 45.3746C6.13637 45.3746 3.32429 47.7695 2.64258 50.9342H4.60251C5.24162 48.7959 7.20155 47.2563 9.50234 47.2563ZM9.50234 57.5202C7.20155 57.5202 5.24162 55.9806 4.60251 53.8423H2.64258C3.32429 57.007 6.13637 59.4019 9.50234 59.4019C12.8683 59.4019 15.6804 57.007 16.3621 53.8423H14.4022C13.7631 55.9806 11.8031 57.5202 9.50234 57.5202Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9531 50.5493L15.9356 52.4738L16.9156 49.1808L12.9531 50.5493Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00862 54.4838L3.40958 52.2172L1.96094 55.4246L6.00862 54.4838Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4955 143.138V150.579H42.2246V143.138L48.36 146.858L54.4955 143.138Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4955 142.453L48.36 146.174L42.2246 142.453H54.4955Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5382 6.79977C54.5382 10.2638 51.7262 13.0864 48.275 13.0864C44.8238 13.0864 42.0117 10.2638 42.0117 6.79977C42.0117 3.33573 44.8238 0.513184 48.275 0.513184C51.7688 0.513184 54.5382 3.33573 54.5382 6.79977Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4475 9.87891H46.1016V14.8825H50.4475V9.87891Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1728 15.8234C51.1728 16.1227 50.9597 16.3366 50.6615 16.3366H45.8043C45.506 16.3366 45.293 16.1227 45.293 15.8234C45.293 15.524 45.506 15.3102 45.8043 15.3102H50.7041C50.9597 15.3102 51.1728 15.524 51.1728 15.8234Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1728 17.2346C51.1728 17.534 50.9597 17.7478 50.6615 17.7478H45.8043C45.506 17.7478 45.293 17.534 45.293 17.2346C45.293 16.9353 45.506 16.7214 45.8043 16.7214H50.7041C50.9597 16.7214 51.1728 16.9353 51.1728 17.2346Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8548 7.99722L50.1931 6.32935L48.361 8.25381L46.5289 6.32935L44.8672 7.99722",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.373 7.69786C109.799 6.97084 110.012 6.11552 110.012 5.17467C110.012 2.30936 107.711 0 104.857 0C102.002 0 99.7012 2.30936 99.7012 5.17467C99.7012 6.07276 99.9568 6.92808 100.34 7.69786L100.383 7.74063C100.468 7.91169 100.596 8.08276 100.681 8.21105L104.857 14.7542L109.032 8.21105C109.16 8.03999 109.245 7.91169 109.373 7.69786Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.857 8.21106C106.528 8.21106 107.882 6.85163 107.882 5.17468C107.882 3.49774 106.528 2.13831 104.857 2.13831C103.186 2.13831 101.832 3.49774 101.832 5.17468C101.832 6.85163 103.186 8.21106 104.857 8.21106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9955 78.6038C29.9955 86.9003 23.2635 93.6574 14.9977 93.6574C6.73194 93.6146 0 86.9003 0 78.6038C0 70.3072 6.73194 63.5502 14.9977 63.5502C23.2635 63.5502 29.9955 70.2644 29.9955 78.6038Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4738 73.7284L24.925 70.9059L22.539 70.521L22.2833 67.9978L19.8547 71.0342L19.6417 72.5738L18.5339 73.6857C17.5113 72.8731 16.2331 72.3599 14.8271 72.3599C11.5889 72.3599 8.94727 75.0114 8.94727 78.2616C8.94727 81.5118 11.5889 84.1633 14.8271 84.1633C18.0652 84.1633 20.7069 81.5118 20.7069 78.2616C20.7069 76.8504 20.1956 75.5246 19.3434 74.4982L20.2808 73.5574L21.4738 73.7284ZM19.5139 78.2616C19.5139 80.8704 17.3835 83.0087 14.7845 83.0087C12.1854 83.0087 10.0551 80.8704 10.0551 78.2616C10.0551 75.6529 12.1854 73.5146 14.7845 73.5146C15.8922 73.5146 16.8722 73.8995 17.6817 74.4982L16.4461 75.7384C15.9775 75.4391 15.4236 75.2252 14.7845 75.2252C13.1228 75.2252 11.802 76.551 11.802 78.2189C11.802 79.8867 13.1228 81.2125 14.7845 81.2125C16.4461 81.2125 17.767 79.8867 17.767 78.2189C17.767 77.5774 17.5965 77.0214 17.2557 76.551L18.4913 75.3108C19.1304 76.1661 19.5139 77.1925 19.5139 78.2616ZM16.6592 78.2616C16.6592 79.288 15.8496 80.1006 14.8271 80.1006C13.8045 80.1006 12.995 79.288 12.995 78.2616C12.995 77.2352 13.8045 76.4227 14.8271 76.4227C15.1253 76.4227 15.381 76.5082 15.6366 76.6365L14.401 77.8767C14.188 78.0906 14.188 78.4755 14.401 78.6893C14.5288 78.8176 14.6566 78.8603 14.8271 78.8603C14.9549 78.8603 15.1253 78.8176 15.2531 78.6893L16.4887 77.4491C16.574 77.7057 16.6592 77.9623 16.6592 78.2616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.234 81.2124C150.234 89.509 143.502 96.266 135.236 96.266C126.97 96.266 120.238 89.509 120.238 81.2124C120.238 72.9158 126.97 66.1588 135.236 66.1588C143.544 66.1588 150.234 72.9158 150.234 81.2124Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.808 71.1196C129.058 71.1196 126.033 74.156 126.033 77.9194C126.033 81.6828 129.058 84.7192 132.808 84.7192C136.557 84.7192 139.582 81.6828 139.582 77.9194C139.582 74.156 136.557 71.1196 132.808 71.1196ZM132.765 83.3934C129.74 83.3934 127.269 80.913 127.269 77.8766C127.269 74.8403 129.74 72.3598 132.765 72.3598C135.79 72.3598 138.261 74.8403 138.261 77.8766C138.261 80.913 135.79 83.3934 132.765 83.3934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.037 89.2096L144.142 90.1077C143.886 90.3643 143.503 90.3643 143.247 90.1077L136.004 82.8375L137.836 80.9985L145.079 88.2687C145.292 88.5253 145.292 88.953 145.037 89.2096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.551 73.4718C134.212 73.4718 135.661 74.4126 136.428 75.7812",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.316 81.4263H129.611V88.0978H131.316V81.4263Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.212 80.2288H132.508V88.0977H134.212V80.2288Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.941 78.8175H135.236V88.1405H136.941V78.8175Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.853 37.4629C134.853 45.7595 128.121 52.5165 119.855 52.5165C111.589 52.5165 104.857 45.7595 104.857 37.4629C104.857 29.1663 111.589 22.4093 119.855 22.4093C128.121 22.4093 134.853 29.1663 134.853 37.4629Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.486 36.3938C114.486 37.2919 113.762 38.0189 112.867 38.0189C111.972 38.0189 111.248 37.2919 111.248 36.3938C111.248 35.4957 111.972 34.7687 112.867 34.7687C113.762 34.7687 114.486 35.4957 114.486 36.3938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.464 36.6504H112.271V39.3874H113.464V36.6504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.868 37.8479C112.825 37.8479 112.825 37.8479 112.783 37.8479C112.74 37.8479 112.74 37.8479 112.698 37.8479C111.249 37.9334 109.971 38.8743 109.971 41.0981H112.698H112.868H115.595C115.595 38.8743 114.317 37.9334 112.868 37.8479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.633 36.3938C128.633 37.2919 127.908 38.0189 127.014 38.0189C126.119 38.0189 125.395 37.2919 125.395 36.3938C125.395 35.4957 126.119 34.7687 127.014 34.7687C127.908 34.7259 128.633 35.4957 128.633 36.3938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.611 36.6504H126.418V39.3874H127.611V36.6504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.014 37.8478C126.972 37.8478 126.972 37.8478 126.929 37.8478C126.887 37.8478 126.887 37.8478 126.844 37.8478C125.395 37.9333 124.117 38.8742 124.117 41.098H126.844H127.014H129.741C129.741 38.8742 128.463 37.9333 127.014 37.8478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.346 29.8506C121.346 30.7487 120.621 31.4757 119.726 31.4757C118.832 31.4757 118.107 30.7487 118.107 29.8506C118.107 28.9525 118.832 28.2255 119.726 28.2255C120.621 28.2255 121.346 28.9525 121.346 29.8506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.324 30.1072H119.131V32.8442H120.324V30.1072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.727 31.3047C119.685 31.3047 119.685 31.3047 119.642 31.3047C119.6 31.3047 119.6 31.3047 119.557 31.3047C118.108 31.3902 116.83 32.3311 116.83 34.5549H119.557H119.727H122.454C122.454 32.3311 121.176 31.3902 119.727 31.3047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.929 37.2063C126.929 41.1408 123.776 44.3055 119.856 44.3055C115.936 44.3055 112.783 41.1408 112.783 37.2063C112.783 33.2719 115.936 30.1072 119.856 30.1072C123.733 30.1072 126.929 33.2719 126.929 37.2063Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6579 52.3882C39.9409 52.3882 46.6556 45.6485 46.6556 37.3346C46.6556 29.0207 39.9409 22.281 31.6579 22.281C23.3749 22.281 16.6602 29.0207 16.6602 37.3346C16.6602 45.6485 23.3749 52.3882 31.6579 52.3882Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0951 37.3774C40.0951 42.0389 36.3031 45.8451 31.6589 45.8451C27.0147 45.8451 23.2227 42.0389 23.2227 37.3774H31.6589V28.9098C36.3457 28.9098 40.0951 32.716 40.0951 37.3774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1667 27.413V35.8806H21.7305C21.7305 31.2191 25.5225 27.413 30.1667 27.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4499 39.5585H33.2344V47.0425H35.4499V39.5585Z",
    fill: "#ED1C24",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3816 43.0225H30.166V46.9997H32.3816V43.0225Z",
    fill: "#ED1C24",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6023 36.7358H36.3867V47.0424H38.6023V36.7358Z",
    fill: "#ED1C24",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.361 137.45C41.6441 137.45 48.3588 130.71 48.3588 122.396C48.3588 114.082 41.6441 107.342 33.361 107.342C25.078 107.342 18.3633 114.082 18.3633 122.396C18.3633 130.71 25.078 137.45 33.361 137.45Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6014 120.001C38.3457 120.001 38.0475 120.044 37.8345 120.129C37.9197 119.787 37.9623 119.445 37.9623 119.06C37.9623 116.494 35.9171 114.442 33.3607 114.442C31.1877 114.442 29.3556 115.981 28.8869 117.991C27.0974 118.119 25.6914 119.616 25.6914 121.455C25.6914 123.38 27.2679 124.962 29.1852 124.962H38.644C40.0074 124.962 41.1152 123.85 41.1152 122.482C41.0726 121.113 39.9648 120.001 38.6014 120.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2584 127.442V123.251H34.5541V127.442H33.1055L34.2559 128.64L35.4063 129.88L36.5567 128.64L37.7071 127.442H36.2584Z",
    fill: "#ED1C24",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4013 129.837V123.251H29.6971V129.837H28.291L29.4414 131.035L30.5492 132.275L31.6996 131.035L32.85 129.837H31.4013Z",
    fill: "#ED1C24",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9232 138.989C90.9232 147.286 84.1913 154.043 75.9255 154.043C67.6597 154.043 60.9277 147.286 60.9277 138.989C60.9277 130.693 67.6597 123.936 75.9255 123.936C84.2339 123.936 90.9232 130.65 90.9232 138.989Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9256 132.574C73.1561 135.739 69.918 136.038 69.918 136.038C70.3866 145.875 75.9256 146.773 75.9256 146.773C75.9256 146.773 81.4645 145.875 81.9332 136.038C81.9332 136.038 78.695 135.739 75.9256 132.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9254 145.447C75.0307 145.147 71.8778 143.693 71.2812 137.065C72.4316 136.723 74.2211 135.996 75.9254 134.413C77.6723 135.996 79.4618 136.723 80.5696 137.065C79.9731 143.693 76.8202 145.147 75.9254 145.447Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9238 139.417L75.969 141.341L78.5254 138.177",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.011 141.983L73.625 139.716L74.2215 139.117L75.9258 140.7L78.184 137.92L78.8657 138.433L76.011 141.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.441 103.878C146.441 104.52 144.396 105.076 141.84 105.076C139.326 105.076 137.238 104.52 137.238 103.878C137.238 103.237 139.283 102.681 141.84 102.681C144.354 102.681 146.441 103.237 146.441 103.878Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84 107.984C144.381 107.984 146.441 107.448 146.441 106.786C146.441 106.125 144.381 105.589 141.84 105.589C139.298 105.589 137.238 106.125 137.238 106.786C137.238 107.448 139.298 107.984 141.84 107.984Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.442 104.691V106.786H137.281V104.691C138.176 105.375 140.392 105.589 141.883 105.589C143.289 105.589 145.547 105.375 146.442 104.691Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.441 109.652C146.441 110.293 144.396 110.849 141.84 110.849C139.326 110.849 137.238 110.293 137.238 109.652C137.238 109.01 139.283 108.454 141.84 108.454C144.354 108.454 146.441 108.968 146.441 109.652Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.442 107.556V109.652H137.281V107.556C138.176 108.241 140.392 108.454 141.883 108.454C143.289 108.454 145.547 108.241 146.442 107.556Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84 113.672C144.381 113.672 146.441 113.136 146.441 112.474C146.441 111.813 144.381 111.277 141.84 111.277C139.298 111.277 137.238 111.813 137.238 112.474C137.238 113.136 139.298 113.672 141.84 113.672Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.442 110.379V112.474H137.281V110.379C138.176 111.063 140.392 111.277 141.883 111.277C143.289 111.277 145.547 111.106 146.442 110.379Z",
    fill: "#ED1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114:4867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 154,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKv5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kv-5.d518c818.svg";
export { ForwardRef as ReactComponent };